module.exports = __webpack_public_path__ + "static/media/company-img.69f824c0.svg";